// extracted by mini-css-extract-plugin
module.exports = {"VerdictCardTitleWrapper":"VerdictCard_VerdictCardTitleWrapper__3qoSW","VerdictCardDescriptionWrapper":"VerdictCard_VerdictCardDescriptionWrapper__3WQOx"};